import { ToastProvider } from "@design";
import { type QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { type ComponentType, type ReactNode, useState } from "react";
import { RouterProvider } from "react-router";
import { ThemeProvider } from "@/theme/ThemeProvider";
import { createQueryClient } from "./queryClient";
import { createRouter } from "./router";

export type AuthProviderComponent = ComponentType<{ children: ReactNode }>;

/**
 * Provider stack. Order matters:
 *   QueryClient (outermost: auth providers clear it when the identity changes)
 *   → Theme → Toast → Auth (MSAL or dev personas, chosen in main.tsx) → Router
 */
export function App({
  AuthProvider,
  queryClient: providedClient,
}: Readonly<{ AuthProvider: AuthProviderComponent; queryClient?: QueryClient }>) {
  const [queryClient] = useState(() => providedClient ?? createQueryClient());
  const [router] = useState(createRouter);
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ToastProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
